import { useEffect, useState } from "react";
import { useApiClient } from "../../api/ApiClientContext.js";
import { LoadingState } from "../../ui/LoadingState.js";
import { ManagerCalendar } from "./ManagerCalendar.js";
import type { ManagerSurfaceMode } from "./model/types.js";

function readModeFromLocation(): { mode: ManagerSurfaceMode; leadId: number | null } {
  if (typeof window === "undefined") {
    return { mode: "global", leadId: null };
  }
  const params = new URLSearchParams(window.location.search);
  const leadRaw = params.get("leadId") ?? params.get("lead");
  if (leadRaw && /^\d+$/.test(leadRaw)) {
    return { mode: "deal", leadId: Number(leadRaw) };
  }
  const pathMatch = window.location.pathname.match(/\/deal\/(\d+)/);
  if (pathMatch?.[1]) {
    return { mode: "deal", leadId: Number(pathMatch[1]) };
  }
  return { mode: "global", leadId: null };
}

export function ManagerCalendarPage() {
  const api = useApiClient();
  const [handoffState, setHandoffState] = useState<"idle" | "pending" | "ready" | "error">(() =>
    typeof window !== "undefined" && window.location.hash.startsWith("#handoff=")
      ? "pending"
      : "idle",
  );
  const { mode, leadId } = readModeFromLocation();
  useEffect(() => {
    if (handoffState !== "pending") return;
    const params = new URLSearchParams(window.location.hash.slice(1));
    const token = params.get("handoff");
    if (!token) {
      setHandoffState("error");
      return;
    }
    void api
      .exchangeSessionHandoff(token)
      .then(() => {
        window.history.replaceState(
          null,
          "",
          `${window.location.pathname}${window.location.search}`,
        );
        setHandoffState("ready");
      })
      .catch(() => setHandoffState("error"));
  }, [api, handoffState]);

  if (handoffState === "pending") {
    return <LoadingState label="Вход через AmoCRM…" testId="amo-handoff-loading" />;
  }
  return <ManagerCalendar mode={mode} leadId={leadId} />;
}

export { ManagerCalendar };
